import {
  ActivitiesAndWorkersKey,
  ActivitiesAndWorkersLabel,
  FoundationKey,
  FoundationLabel,
  GovernanceKey,
  GovernanceLabel,
  OrganizationalProfileKey,
  OrganizationalProfileLabel,
  StakeholderEngagementKey,
  StakeholderEngagementLabel,
  StrategyPoliciesAndPracticesKey,
  StrategyPoliciesAndPracticesLabel
} from '../../../../components/Forms/Constants/General/QuestionsKeyLabel';
import {inputType} from '../../interface/inputType';

/* eslint-disable max-len */
export const foundationTabQuestions = [
  {
    key: '1',
    label: FoundationLabel.F_FOUNDATION_1,
    kpiId: '101-1',
    items: [
      {
        question: 'Reporting Principles',
        field: [
          {
            fieldType: inputType.MULTISELECT,
            fieldName: FoundationKey.F_QUESTION_1,
            fieldLabel: FoundationLabel.F_QUESTION_1,
            options: [
              {label: 'GRI', value: 'GRI'},
              {label: 'BRSR', value: 'BRSR'},
              {label: 'SASB', value: 'SASB'},
              {label: 'CDP', value: 'CDP'}
            ]
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: FoundationLabel.F_FOUNDATION_2,
    kpiId: '101-2',
    items: [
      {
        question: 'Using the GRI Standards for sustainability reporting',
        field: [
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: FoundationKey.F_QUESTION_2,
            fieldLabel: FoundationLabel.F_QUESTION_2,
            options: ['Yes', 'No']
          }
        ]
      }
    ]
  },
  {
    key: '3',
    label: FoundationLabel.F_FOUNDATION_3,
    kpiId: '101-3',
    items: [
      {
        question: 'Making claims related to the use of the GRI Standards',
        field: [
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: FoundationKey.F_QUESTION_3,
            fieldLabel: FoundationLabel.F_QUESTION_3,
            options: ['Yes', 'No']
          }
        ]
      }
    ]
  }
];

export const organizationalProfileTabQuestions = [
  {
    key: '1',
    label: OrganizationalProfileLabel.OP_ORGANIZATIONAL_PROFILE_1,
    kpiId: '2-1',
    items: [
      {
        question: 'a. Report its legal name.',
        tooltip:
          'If the organization uses a commonly known trading name or business name that is differentfrom its legal name, it should report this in addition to its legal name.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OrganizationalProfileKey.OP_QUESTION_1,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_1
          }
        ]
      },
      {
        question: 'b. Report its nature of ownership and legal form.',
        tooltip:
          'The nature of ownership and the legal form of the organization refers to whether it is publicly or privately owned, and whether it is an incorporated entity, a partnership, a sole proprietorship, or another type of entity such as a nonprofit, an association, or a charity.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OrganizationalProfileKey.OP_QUESTION_2,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_2
          }
        ]
      },
      {
        question: 'c. Report the location of its headquarters.',
        tooltip:
          'Headquarters are an organization’s global administrative center, the place from which it is controlled or directed.',
        field: [
          {
            fieldType: inputType.TEXT,
            fieldName: OrganizationalProfileKey.OP_QUESTION_3,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_3
          },
          {
            fieldType: inputType.TEXT,
            fieldName: OrganizationalProfileKey.OP_QUESTION_4,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_4
          },
          {
            fieldType: inputType.TEXT,
            fieldName: OrganizationalProfileKey.OP_QUESTION_5,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_5
          },
          {
            fieldType: inputType.TEXT,
            fieldName: OrganizationalProfileKey.OP_QUESTION_6,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_6
          },
          {
            fieldType: inputType.TEXT,
            fieldName: OrganizationalProfileKey.OP_QUESTION_7,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_7
          },
          {
            fieldType: inputType.COUNTRY,
            fieldName: OrganizationalProfileKey.OP_QUESTION_8,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_8
          }
        ]
      },
      {
        question: 'd. Report its countries of operation.',
        tooltip:
          'If the organization has reported its countries of operation elsewhere, such as in its audited consolidated financial statements or financial information filed on public record, the organization can provide a link or reference to this information. The organization can also report the regions or specific locations within countries (e.g., states, cities) where it has operations, if this provides contextual information for understanding the organization’s impacts.',
        field: [
          {
            fieldType: inputType.COUNTRY,
            fieldName: OrganizationalProfileKey.OP_QUESTION_9,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_9,
            selectionModeMultiple: 'multiple',
            inputWidth: '400px'
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: OrganizationalProfileLabel.OP_ORGANIZATIONAL_PROFILE_2,
    kpiId: '2-2',
    items: [
      {
        question:
          'a. List all its entities included in its sustainability reporting.',
        field: [
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'organizationalEntities',
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: OrganizationalProfileLabel.OP_HEADING_1
                },
                {
                  type: inputType.TEXT,
                  fieldName: OrganizationalProfileKey.OP_QUESTION_10,
                  fieldLabel: OrganizationalProfileLabel.OP_QUESTION_10,
                  placeHolder: ''
                }
              ]
            }
          }
        ]
      },
      {
        question:
          'b. If the organization has audited consolidated financial statements or financial information filed on public record, specify the differences between the list of entities included in its financial reporting and the list included in its sustainability reporting.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OrganizationalProfileKey.OP_QUESTION_11,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_11
          }
        ]
      },
      {
        question:
          'c. If the organization consists of multiple entities, explain the approach used for consolidating the information, including:',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: OrganizationalProfileLabel.OP_HEADING_2
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OrganizationalProfileKey.OP_QUESTION_12,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_12
          },
          {
            fieldType: inputType.HEADING,
            heading: OrganizationalProfileLabel.OP_HEADING_3
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OrganizationalProfileKey.OP_QUESTION_13,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_13
          },
          {
            fieldType: inputType.HEADING,
            heading: OrganizationalProfileLabel.OP_HEADING_4
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OrganizationalProfileKey.OP_QUESTION_14,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_14
          }
        ]
      }
    ]
  },
  {
    key: '3',
    label: OrganizationalProfileLabel.OP_ORGANIZATIONAL_PROFILE_3,
    kpiId: '2-3',
    items: [
      {
        question:
          'a. Specify the reporting period for, and the frequency of, its sustainability reporting.',
        field: [
          {
            fieldType: inputType.DATE_RANGE_PICKER,
            fieldName: OrganizationalProfileKey.OP_QUESTION_15,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_15,
            dateFormat: 'DD-MM-YYYY'
          },
          {
            fieldType: inputType.SELECT,
            fieldName: OrganizationalProfileKey.OP_QUESTION_16,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_16,
            tooltip:
              'The organization can specify the frequency of sustainability reporting as ‘annual’.',
            options: [
              {label: 'Weekly', value: 'Weekly'},
              {label: 'Monthly', value: 'Monthly'},
              {label: 'Yearly', value: 'Yearly'}
            ]
          }
        ]
      },
      {
        question:
          'b. Specify the reporting period for its financial reporting and, if it does not align with the period for its sustainability reporting, explain the reason for thisb. If the organization has audited consolidated financial statements or financial information filed on public record, specify the differences between the list of entities included in its financial reporting and the list included in its sustainability reporting.',
        field: [
          {
            fieldType: inputType.DATE_RANGE_PICKER,
            fieldName: OrganizationalProfileKey.OP_QUESTION_17,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_17,
            dateFormat: 'DD-MM-YYYY',
            tooltip:
              'The reporting period refers to the time period covered by the reported information and should include the start and end dates (e.g., 1 January 2022 to 31 December 2022, 1 July 2022 through 30 June 2023). The organization should report the information for the same reporting period as covered in its financial reporting. The organization should also publish the information at the same time as its financial reporting, where this is possible.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OrganizationalProfileKey.OP_QUESTION_18,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_18
          }
        ]
      },
      {
        question:
          'c. Report the publication date of the report or reported information.',
        field: [
          {
            fieldType: inputType.DATE_RANGE_PICKER,
            fieldName: OrganizationalProfileKey.OP_QUESTION_19,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_19,
            dateFormat: 'DD-MM-YYYY'
          }
        ]
      },
      {
        question:
          'd. Specify the contact point for questions about the report or reported information.',
        field: [
          {
            fieldType: inputType.TEXT,
            fieldName: OrganizationalProfileKey.OP_QUESTION_20,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_20
          },
          {
            fieldType: inputType.TEXT,
            fieldName: OrganizationalProfileKey.OP_QUESTION_21,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_21
          },
          {
            fieldType: inputType.TEXT,
            fieldName: OrganizationalProfileKey.OP_QUESTION_22,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_22
          }
        ]
      }
    ]
  },
  {
    key: '4',
    label: OrganizationalProfileLabel.OP_ORGANIZATIONAL_PROFILE_4,
    kpiId: '2-4',
    items: [
      {
        question:
          'a. Report restatements of information made from previous reporting periods and explain:',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: OrganizationalProfileLabel.OP_HEADING_8
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OrganizationalProfileKey.OP_QUESTION_23,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_23
          },
          {
            fieldType: inputType.HEADING,
            heading: OrganizationalProfileLabel.OP_HEADING_9
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OrganizationalProfileKey.OP_QUESTION_24,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_24
          }
        ]
      }
    ]
  },
  ,
  {
    key: '5',
    label: OrganizationalProfileLabel.OP_ORGANIZATIONAL_PROFILE_5,
    kpiId: '2-5',
    items: [
      {
        question:
          'a. Describe its policy and practice for seeking external assurance, including whether and how the highest governance body and senior executives are involved.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OrganizationalProfileKey.OP_QUESTION_25,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_25
          }
        ]
      },
      {
        question:
          'b. If the organization’s sustainability reporting has been externally assured:',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: OrganizationalProfileLabel.OP_HEADING_5
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OrganizationalProfileKey.OP_QUESTION_26,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_26
          },
          {
            fieldType: inputType.HEADING,
            heading: OrganizationalProfileLabel.OP_HEADING_6,
            tooltip:
              'If this information is covered in the external assurance reports or statements that the organization has provided a link or a reference to under 2-5-b-i, then a brief statement of this fact is sufficient to comply with the requirement. The organization can also describe, in accessible language: • the scope of information and processes covered. • the responsibilities of the organization relative to the assurance provider. • the opinion or conclusions formally signed off by the assurance provider. • a summary of the work performed. • information on the experience and qualifications of the assurance provider, e.g., profile and level of subject matter expertise of the individuals involved.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OrganizationalProfileKey.OP_QUESTION_27,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_27
          },
          {
            fieldType: inputType.HEADING,
            heading: OrganizationalProfileLabel.OP_HEADING_7,
            tooltip:
              'An assurance provider conducting external assurance needs to demonstrate independence from the organization to reach and publish objective and impartial conclusions about the organization’s sustainability reporting.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OrganizationalProfileKey.OP_QUESTION_28,
            fieldLabel: OrganizationalProfileLabel.OP_QUESTION_28
          }
        ]
      }
    ]
  }
];

export const activitiesAndWorkersTabQuestions = [
  {
    key: '1',
    label: ActivitiesAndWorkersLabel.AAW_ACTIVITIES_AND_WORKERS_1,
    kpiId: '2-6',
    items: [
      {
        question: 'a. Report the sector(s) in which it is active.',
        tooltip:
          'Sectors can be identified according to categories, such as the public or private sector. orindustry-specific categories, such as the education sector or the financial sector.Depending on the organization’s activities, sectors can be identified using the GRI SectorStandards or classification systems such as the Global Industry Classification Standard(GICS®), the Industry Classification Benchmark (ICB), the International Standard IndustrialClassification of All Economic Activities (ISIC), and the Sustainable Industry ClassificationSystem (SICS®).',
        field: [
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'sectors',
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: ActivitiesAndWorkersLabel.AAW_HEADING_1
                },
                {
                  type: inputType.TEXT,
                  fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_1,
                  fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_1,
                  placeHolder: ''
                }
              ]
            }
          }
        ]
      },
      {
        question: 'b. Describe its value chain, including: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: ActivitiesAndWorkersLabel.AAW_HEADING_7,
            tooltip:
              'The organization’s value chain includes the range of activities carried out by the organization,and by entities upstream and downstream from the organization, to bring the organization’sproducts or services from their conception to their end use. Entities upstream from the organization provide products or services used in the development of the organization’s own products or services. Entities downstream from the organization are those that receive products or services from the organization. Entities in the value chain include entities beyond the first tier, both upstream and downstream. The information reported under 2-6-b provides a context for understanding the organization’s impacts across its value chain, including through the use of its products and services. Describing the markets served provides further information on the groups of customers targeted by the organization’s products and services. The organization is not required to provide a detailed description of each activity in its value chain. Instead, it can provide a high-level overview of its value chain. When describing its activities, the organization should report its total number of operations and explain how it defines ‘operation’. When describing its products and services, the organization should report: GUIDANCE the quantity of products or services provided during the reporting period (e.g., number of products or services provided, net sales of products or services provided). • whether it sells products or services that are banned in certain markets or are the subject of stakeholder concerns or public debate, including the reason for the ban or concerns and how the organization has responded to these concerns. When describing the markets served, the organization can report: • the geographic locations where products and services are offered. • the demographic or other characteristics of the markets. • information on the size and relative importance of the markets (e.g., net sales, net revenues).'
          },
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'valueChains',
              formFields: [
                {
                  type: inputType.TEXTAREA,
                  fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_2,
                  fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_2,
                  placeHolder: ''
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: ActivitiesAndWorkersLabel.AAW_HEADING_8,
            tooltip:
              'The organization can describe: • the types of suppliers (e.g., brokers, contractors, wholesalers). the estimated number of suppliers throughout its supply chain and in each tier (e.g., first tier,second tier). • the types of activities related to the organization’s products and services carried out by its suppliers (e.g., manufacturing, providing consulting services). • the nature of its business relationships with its suppliers (e.g., long-term or short-term, contractual or non-contractual, project-based or event-based). • the sector-specific characteristics of its supply chain (e.g., labor-intensive). • the estimated monetary value of payments made to its suppliers. • the geographic location of its suppliers.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_3,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_3,
            placeHolder: ''
          },
          {
            fieldType: inputType.HEADING,
            heading: ActivitiesAndWorkersLabel.AAW_HEADING_9,
            tooltip:
              'The organization’s value chain includes the range of activities carried out by the organization,and by entities upstream and downstream from the organization, to bring the organization’sproducts or services from their conception to their end use. Entities upstream from the organization provide products or services used in the development of the organization’s own products or services. Entities downstream from the organization are those that receive products or services from the organization. Entities in the value chain include entities beyond the first tier, both upstream and downstream. The information reported under 2-6-b provides a context for understanding the organization’s impacts across its value chain, including through the use of its products and services. Describing the markets served provides further information on the groups of customers targeted by the organization’s products and services. The organization is not required to provide a detailed description of each activity in its value chain. Instead, it can provide a high-level overview of its value chain. When describing its activities, the organization should report its total number of operations and explain how it defines ‘operation’. When describing its products and services, the organization should report: GUIDANCE the quantity of products or services provided during the reporting period (e.g., number of products or services provided, net sales of products or services provided). • whether it sells products or services that are banned in certain markets or are the subject of stakeholder concerns or public debate, including the reason for the ban or concerns and how the organization has responded to these concerns. When describing the markets served, the organization can report: • the geographic locations where products and services are offered. • the demographic or other characteristics of the markets. • information on the size and relative importance of the markets (e.g., net sales, net revenues).'
          },
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'valueChainsEntities',
              formFields: [
                {
                  type: inputType.TEXTAREA,
                  fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_4,
                  fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_4,
                  placeHolder: ''
                }
              ]
            }
          }
        ]
      },
      {
        question: 'c. Report other relevant business relationships',
        tooltip:
          'Other relevant business relationships include relationships that the organization has with entities that are not described as part of its value chain under 2-6-b. These may include business partners (e.g., joint ventures) and other entities directly linked to the organization’s operations, products, or services (for examples, see the note in the definition of ‘business relationships’). The organization can report the types of entities, their activities, and their geographic location.',
        field: [
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'bussinessRelationships',
              formFields: [
                {
                  type: inputType.TEXTAREA,
                  fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_5,
                  fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_5,
                  placeHolder: ''
                }
              ]
            }
          }
        ]
      },
      {
        question:
          'd. Describe significant changes in 2-6-a, 2-6-b, and 2-6-c compared to the previous reporting period.',
        tooltip:
          'Requirement 2-6-d entails describing significant changes in the organization’s sectors, value chain, and other business relationships compared to the previous reporting period. This information can help explain changes to the organization’s impacts. Examples of significant changes that can be reported under this disclosure are changes in activities such as the opening, closing, or expansion of facilities. changes in the structure of the organization’s supply chain or in its relationships with suppliers, including selection and termination. or changes in the location of its suppliers.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_6,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_6,
            placeHolder: ''
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: ActivitiesAndWorkersLabel.AAW_ACTIVITIES_AND_WORKERS_2,
    kpiId: '2-7',
    items: [
      {
        question:
          'a. Report the total number of employees, and a breakdown of this total.',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: ActivitiesAndWorkersLabel.AAW_HEADING_17,
            tooltip: 'By gender Male , Female'
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_7,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_7
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_8,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_8
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_9,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_9
          },
          {
            fieldType: inputType.HEADING,
            heading: ActivitiesAndWorkersLabel.AAW_HEADING_18,
            tooltip:
              'Total number of employee in the reporting period shall be classified as following: Asia, APAC, North America, South America, Europe'
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_10,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_10
          },
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'totalNumberOfEmployeesByRegion',
              formFields: [
                {
                  fieldType: inputType.NUMBER,
                  fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_11,
                  fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_11,
                  placeHolder: 'Region'
                },
                {
                  fieldType: inputType.NUMBER,
                  fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_12,
                  fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_12,
                  placeHolder: 'Employee'
                }
              ]
            }
          }
        ]
      },
      {
        question: 'b. Report the total number of:',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: ActivitiesAndWorkersLabel.AAW_HEADING_10,
            tooltip:
              'Total number of employee in the reporting period shall be classified as following: drop down region : Asia, APAC, North America, South America, Europe total permanent male employees total permanent female employees'
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_14,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_14
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_15,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_15
          },
          {
            fieldType: inputType.HEADING,
            heading: ActivitiesAndWorkersLabel.AAW_HEADING_2
          },
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'totalNumberOfPermanentEmployeesByRegion',
              formFields: [
                {
                  fieldType: inputType.TEXT,
                  fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_16,
                  fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_16,
                  placeHolder: 'Region'
                },
                {
                  fieldType: inputType.NUMBER,
                  fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_17,
                  fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_17,
                  placeHolder: 'Permanent Male Employee'
                },
                {
                  fieldType: inputType.NUMBER,
                  fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_18,
                  fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_18,
                  placeHolder: 'Permanent Female Employee'
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: ActivitiesAndWorkersLabel.AAW_HEADING_11,
            tooltip:
              'Total number of employee in the reporting period shall be classified as following: drop down region : Asia, APAC, North America, South America, Europe total temporary male employees total temporary female employees'
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_19,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_19
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_20,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_20
          },
          {
            fieldType: inputType.HEADING,
            heading: ActivitiesAndWorkersLabel.AAW_HEADING_3
          },
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'totalNumberOfTemporaryEmployeesByRegion',
              formFields: [
                {
                  fieldType: inputType.TEXT,
                  fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_21,
                  fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_21,
                  placeHolder: 'Region'
                },
                {
                  fieldType: inputType.NUMBER,
                  fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_22,
                  fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_22,
                  placeHolder: 'Temporary Male Employee'
                },
                {
                  fieldType: inputType.NUMBER,
                  fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_23,
                  fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_23,
                  placeHolder: 'Temporary Female Employee'
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: ActivitiesAndWorkersLabel.AAW_HEADING_12,
            tooltip:
              'Total number of employee in the reporting period shall be classified as following: drop down region : Asia, APAC, North America, South America, Europe total non-guaranteed hours employee male total non-guaranteed hours employee female'
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_24,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_24
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_25,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_25
          },
          {
            fieldType: inputType.HEADING,
            heading: ActivitiesAndWorkersLabel.AAW_HEADING_4
          },
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'totalNumberOfNonGuaranteedHoursEmployeesByRegion',
              formFields: [
                {
                  fieldType: inputType.TEXT,
                  fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_26,
                  fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_26,
                  placeHolder: 'Region'
                },
                {
                  fieldType: inputType.NUMBER,
                  fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_27,
                  fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_27,
                  placeHolder: 'Non-guaranteed hours Male Employee'
                },
                {
                  fieldType: inputType.NUMBER,
                  fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_28,
                  fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_28,
                  placeHolder: 'Non-guaranteed hours Female Employee'
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: ActivitiesAndWorkersLabel.AAW_HEADING_13,
            tooltip:
              'Total number of employee in the reporting period shall be classified as following: drop down region : Asia, APAC, North America, South America, Europe total full-time employee male total full-time employee female'
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_29,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_29
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_30,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_30
          },
          {
            fieldType: inputType.HEADING,
            heading: ActivitiesAndWorkersLabel.AAW_HEADING_5
          },
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'totalNumberOfFullTimeEmployeesByRegion',
              formFields: [
                {
                  fieldType: inputType.TEXT,
                  fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_31,
                  fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_31,
                  placeHolder: 'Region'
                },
                {
                  fieldType: inputType.NUMBER,
                  fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_32,
                  fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_32,
                  placeHolder: 'Full TIme Male Employee'
                },
                {
                  fieldType: inputType.NUMBER,
                  fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_33,
                  fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_33,
                  placeHolder: 'Full TIme Female Employee'
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: ActivitiesAndWorkersLabel.AAW_HEADING_14,
            tooltip:
              'Total number of employee in the reporting period shall be classified as following: drop down region : Asia, APAC, North America, South America, Europe total part-time employee male total part-time employee female'
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_34,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_34
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_35,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_35
          },
          {
            fieldType: inputType.HEADING,
            heading: ActivitiesAndWorkersLabel.AAW_HEADING_6
          },
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'totalNumberOfFullTimeEmployeesByRegion',
              formFields: [
                {
                  fieldType: inputType.TEXT,
                  fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_36,
                  fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_36,
                  placeHolder: 'Region'
                },
                {
                  fieldType: inputType.NUMBER,
                  fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_37,
                  fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_37,
                  placeHolder: 'Part TIme Male Employee'
                },
                {
                  fieldType: inputType.NUMBER,
                  fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_38,
                  fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_38,
                  placeHolder: 'Part TIme Female Employee'
                }
              ]
            }
          }
        ]
      },
      {
        question:
          'c. Describe the methodologies and assumptions used to compile the data, including whether the numbers are reported: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: ActivitiesAndWorkersLabel.AAW_HEADING_15
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_39,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_39
          },
          {
            fieldType: inputType.HEADING,
            heading: ActivitiesAndWorkersLabel.AAW_HEADING_16
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_40,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_40
          }
        ]
      },
      {
        question:
          'd. Report contextual information necessary to understand the data reported under 2-7-a and 2-7-b.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_41,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_41
          }
        ]
      },
      {
        question:
          'e. Describe significant fluctuations in the number of employees during the reporting period and between reporting periods.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_42,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_42
          }
        ]
      }
    ]
  },
  {
    key: '3',
    label: ActivitiesAndWorkersLabel.AAW_ACTIVITIES_AND_WORKERS_3,
    kpiId: '2-8',
    items: [
      {
        question:
          'a. Report the total number of workers who are not employees and whose work is controlled by the organization',
        tooltip:
          'Workers who are not employees are those who perform work for the organization but are not in an employment relationship with the organization. This disclosure requires the organization to report the number of workers who are not employees and whose work is controlled by the organization.  Control of work implies that the organization directs the work performed or has control over the means or methods for performing the work. The organization might have sole control of the work or share control with one or more organizations (e.g., suppliers, customers, or other business partners, such as in joint ventures). Types of workers who are not employees and whose work is controlled by the organization include agency workers, apprentices, contractors, home workers, interns, self-employed persons, sub-contractors, and volunteers. The organization should report how it has determined when it has control of the work for workers who are not employees. The following are examples of workers who are not employees and whose work is controlled by the organization. The following workers are included under this disclosure: • Contractors hired by the organization to perform work at the organization’s workplace, in a public area (e.g., on a road), or directly at the workplace of the organization’s client. • Workers of one of the organization’s suppliers, where the organization instructs the supplier to use particular materials or work methods to manufacture the products or deliver the services. • Volunteers or interns performing work for the organization',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_43,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_43
          },
          {
            fieldType: inputType.HEADING,
            heading: ActivitiesAndWorkersLabel.AAW_HEADING_19,
            tooltip:
              'When reporting its contractual relationship with the most common types of workers, the organization should report whether it engages them directly or indirectly through a third party, and in the latter case, who this third party is (e.g., employment agency, contractor). It is sufficient that the organization provides a general description. The organization is not required to report the type of worker, contractual relationship, and work performed for every worker who is not an employee.'
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_44,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_44
          },
          {
            fieldType: inputType.HEADING,
            heading: ActivitiesAndWorkersLabel.AAW_HEADING_20,
            tooltip:
              'When reporting its contractual relationship with the most common types of workers, the organization should report whether it engages them directly or indirectly through a third party, and in the latter case, who this third party is (e.g., employment agency, contractor). It is sufficient that the organization provides a general description. The organization is not required to report the type of worker, contractual relationship, and work performed for every worker who is not an employee.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_45,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_45
          }
        ]
      },
      {
        question:
          'b. Describe the methodologies and assumptions used to compile the data, including whether the number of workers who are not employees is reported: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: ActivitiesAndWorkersLabel.AAW_HEADING_21,
            tooltip:
              'The organization can report the number of workers who are not employees in head count or fulltime equivalent (FTE). The head count gives insight into the number of individual workers, whether on a full-time or part-time basis. The FTE gives insight into the hours worked. The organization can use another methodology for reporting this number. Reporting the number of workers who are not employees at the end of the reporting period provides information for that point in time without capturing fluctuations during the reporting period. Reporting this number as an average across the reporting period takes into account fluctuations during the reporting period.'
          },
          {
            fieldType: inputType.SELECT,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_46,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_46,
            inputWidth: '200px',
            options: [
              {label: 'In head count', value: 'In head count'},
              {
                label: 'Full-time equivalent (FTE)',
                value: 'Full-time equivalent (FTE)'
              },
              {label: 'Other', value: 'Other'}
            ]
          },
          {
            fieldType: inputType.HEADING,
            heading: ActivitiesAndWorkersLabel.AAW_HEADING_22,
            tooltip:
              'The organization can report the number of workers who are not employees in head count or fulltime equivalent (FTE). The head count gives insight into the number of individual workers, whether on a full-time or part-time basis. The FTE gives insight into the hours worked. The organization can use another methodology for reporting this number. Reporting the number of workers who are not employees at the end of the reporting period provides information for that point in time without capturing fluctuations during the reporting period. Reporting this number as an average across the reporting period takes into account fluctuations during the reporting period.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_48,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_48
          }
        ]
      },
      {
        question:
          'c. Describe significant fluctuations in the number of workers who are not employees during the reporting period and between reporting periods.',
        tooltip:
          'Requirement 2-8-c enables the organization to explain how the number of workers who are not employees varies during the reporting period or compared to previous reporting periods (i.e., whether the numbers have increased or decreased). It can also include the reasons for the fluctuations. For example, an increase in the number of workers who are not employees during the reporting period could be due to a seasonal event. Conversely, a decrease in the number of workers who are not employees compared to the previous reporting period could be due to the completion of a temporary project. It is up to the organization to determine which fluctuations in the number of workers it considers significant to report under 2-8-c. The organization should report its threshold for determining significant fluctuations.  If there are no significant fluctuations in the number of workers who are not employees during the reporting period or between reporting periods, a brief statement of this fact is sufficient to comply with the requirement.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: ActivitiesAndWorkersKey.AAW_QUESTION_49,
            fieldLabel: ActivitiesAndWorkersLabel.AAW_QUESTION_49
          }
        ]
      }
    ]
  }
];

export const governanceTabQuestions = [
  {
    key: '1',
    label: GovernanceLabel.G_GOVERNANCE_1,
    kpiId: '2-9',
    items: [
      {
        question:
          'a. Describe its governance structure, including committees of the highest governance body.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_1,
            fieldLabel: GovernanceLabel.G_QUESTION_1
          }
        ]
      },
      {
        question:
          'b. List the committees of the highest governance body that are responsible for decision making on and overseeing the management of the organization’s impacts on the economy, environment, and people.',
        tooltip:
          'Ex- Audit committee, ESG committee, Remuneration committee, CSR committee, etc.',
        field: [
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'committees',
              formFields: [
                {
                  type: inputType.HEADING,
                  heading: GovernanceLabel.G_HEADING_1
                },
                {
                  type: inputType.TEXT,
                  fieldName: GovernanceKey.G_QUESTION_2,
                  fieldLabel: GovernanceLabel.G_QUESTION_2,
                  placeHolder: ''
                }
              ]
            }
          }
        ]
      },
      {
        question:
          'c. Describe the composition of the highest governance body and its committees by: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: GovernanceKey.G_QUESTION_3,
            fieldLabel: GovernanceLabel.G_QUESTION_3
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: GovernanceKey.G_QUESTION_4,
            fieldLabel: GovernanceLabel.G_QUESTION_4
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_3
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_5,
            fieldLabel: GovernanceLabel.G_QUESTION_5
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_4
          },
          {
            fieldType: inputType.TEXT,
            fieldName: GovernanceKey.G_QUESTION_6,
            fieldLabel: GovernanceLabel.G_QUESTION_6
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_5
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_7,
            fieldLabel: GovernanceLabel.G_QUESTION_7
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_6,
            tooltip: 'Male board members, female board members'
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: GovernanceKey.G_QUESTION_8,
            fieldLabel: GovernanceLabel.G_QUESTION_8
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: GovernanceKey.G_QUESTION_9,
            fieldLabel: GovernanceLabel.G_QUESTION_9
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_7,
            tooltip:
              'Group of individuals who are less represented within a subset (e.g., a body or committee, employees of an organization) relative to their numbers in the general population, and who therefore have less opportunity to express their economic, social, or political needs and views Note 1: Under-represented social groups may include minority groups. Note 2: The groups included under this definition depend on the organization’s operating context and are not uniform for every organization'
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: GovernanceKey.G_QUESTION_10,
            fieldLabel: GovernanceLabel.G_QUESTION_10
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_8
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_11,
            fieldLabel: GovernanceLabel.G_QUESTION_11
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_9
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_12,
            fieldLabel: GovernanceLabel.G_QUESTION_12
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: GovernanceLabel.G_GOVERNANCE_2,
    kpiId: '2-10',
    items: [
      {
        question:
          'a. Describe the nomination and selection processes for the highest governance body and its committees.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_13,
            fieldLabel: GovernanceLabel.G_QUESTION_13
          }
        ]
      },
      {
        question:
          'b. Describe the criteria used for nominating and selecting highest governance body members, including whether and how the following are taken into consideration: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_10
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_14,
            fieldLabel: GovernanceLabel.G_QUESTION_14
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_11
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_15,
            fieldLabel: GovernanceLabel.G_QUESTION_15
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_12,
            tooltip:
              '‘Independence’ refers to conditions that enable the members of the highest governance body to exercise independent judgment free from any external influence or conflicts of interest.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_16,
            fieldLabel: GovernanceLabel.G_QUESTION_16
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_13,
            tooltip:
              'Competencies relevant to the impacts of the organization include competencies relevant to impacts commonly associated with the organization’s sectors, products, and geographic locations.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_17,
            fieldLabel: GovernanceLabel.G_QUESTION_17
          }
        ]
      }
    ]
  },
  {
    key: '3',
    label: GovernanceLabel.G_GOVERNANCE_3,
    kpiId: '2-11',
    items: [
      {
        question:
          'a. Report whether the chair of the highest governance body is also a senior executive in the organization.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_18,
            fieldLabel: GovernanceLabel.G_QUESTION_18
          }
        ]
      },
      {
        question:
          'b. If the chair is also a senior executive, explain their function within the organization’s management, the reasons for this arrangement, and how conflicts of interest are prevented and mitigated.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_19,
            fieldLabel: GovernanceLabel.G_QUESTION_19
          }
        ]
      }
    ]
  },
  {
    key: '4',
    label: GovernanceLabel.G_GOVERNANCE_4,
    kpiId: '2-12',
    items: [
      {
        question:
          'a. Describe the role of the highest governance body and of senior executives in developing, approving, and updating the organization’s purpose, value or mission statements, strategies, policies, and goals related to sustainable development.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_20,
            fieldLabel: GovernanceLabel.G_QUESTION_20
          }
        ]
      },
      {
        question:
          'b. Describe the role of the highest governance body in overseeing the organization’s due diligence and other processes to identify and manage the organization’s impacts on the economy, environment, and people, including. ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_14,
            tooltip:
              'Requirement 2-12-b-i covers the role of the highest governance body in stakeholder engagement. The organization is also required to report information about stakeholder engagement under other disclosures, such as under the disclosures in section 5 of this Standard. The organization can describe the frequency of engagement between the highest governance body and stakeholders as well as the means of engagement. If stakeholder engagement is delegated, the organization can report to whom it is delegated and how the feedback received is provided to the highest governance body.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_21,
            fieldLabel: GovernanceLabel.G_QUESTION_21
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_15
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_22,
            fieldLabel: GovernanceLabel.G_QUESTION_22
          }
        ]
      },
      {
        question:
          'c. Describe the role of the highest governance body in reviewing the effectiveness of the organization’s processes as described in 2-12-b, and report the frequency of this review.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_23,
            fieldLabel: GovernanceLabel.G_QUESTION_23
          }
        ]
      }
    ]
  },
  {
    key: '5',
    label: GovernanceLabel.G_GOVERNANCE_5,
    kpiId: '2-13',
    items: [
      {
        question:
          'a. Describe how the highest governance body delegates responsibility for managing the organization’s impacts on the economy, environment, and people, including: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_16
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_24,
            fieldLabel: GovernanceLabel.G_QUESTION_24
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_17
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_25,
            fieldLabel: GovernanceLabel.G_QUESTION_25
          }
        ]
      },
      {
        question:
          'b. Describe the process and frequency for senior executives or other employees to report back to the highest governance body on the management of the organization’s impacts on the economy, environment, and people.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_26,
            fieldLabel: GovernanceLabel.G_QUESTION_26
          }
        ]
      }
    ]
  },
  {
    key: '6',
    label: GovernanceLabel.G_GOVERNANCE_6,
    kpiId: '2-14',
    items: [
      {
        question:
          'a. Report whether the highest governance body is responsible for reviewing and approving the reported information, including the organization’s material topics, and if so, describe the process for reviewing and approving the information.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_26_1
          }
        ]
      },
      {
        question:
          'b. If the highest governance body is not responsible for reviewing and approving the reported information, including the organization’s material topics, explain the reason for this.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_27,
            fieldLabel: GovernanceLabel.G_QUESTION_27
          }
        ]
      }
    ]
  },
  {
    key: '7',
    label: GovernanceLabel.G_GOVERNANCE_7,
    kpiId: '2-15',
    items: [
      {
        question:
          'a. Describe the processes for the highest governance body to ensure that conflicts of interest are prevented and mitigated.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_28,
            fieldLabel: GovernanceLabel.G_QUESTION_28
          }
        ]
      },
      {
        question:
          'b. Report whether conflicts of interest are disclosed to stakeholders, including, at a minimum, conflicts of interest relating to: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_18
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_29,
            fieldLabel: GovernanceLabel.G_QUESTION_29
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_19
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_30,
            fieldLabel: GovernanceLabel.G_QUESTION_30
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_20,
            tooltip:
              'The organization should use the definition of controlling shareholder applied in the organization’s consolidated financial statements or equivalent documents.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_31,
            fieldLabel: GovernanceLabel.G_QUESTION_31
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_21
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_32,
            fieldLabel: GovernanceLabel.G_QUESTION_32
          }
        ]
      }
    ]
  },
  {
    key: '8',
    label: GovernanceLabel.G_GOVERNANCE_8,
    kpiId: '2-16',
    items: [
      {
        question:
          'a. Describe whether and how critical concerns are communicated to the highest governance body.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_33,
            fieldLabel: GovernanceLabel.G_QUESTION_33
          }
        ]
      },
      {
        question:
          'b. Report the total number and the nature of critical concerns that were communicated to the highest governance body during the reporting period.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_34,
            fieldLabel: GovernanceLabel.G_QUESTION_34
          }
        ]
      }
    ]
  },
  {
    key: '9',
    label: GovernanceLabel.G_GOVERNANCE_9,
    kpiId: '2-17',
    items: [
      {
        question:
          'a. Report measures taken to advance the collective knowledge, skills, and experience of the highest governance body on sustainable development.',
        field: [
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'skills',
              formFields: [
                {
                  type: inputType.TEXTAREA,
                  fieldName: GovernanceKey.G_QUESTION_35,
                  fieldLabel: GovernanceLabel.G_QUESTION_35,
                  placeHolder: ''
                }
              ]
            }
          }
        ]
      }
    ]
  },
  {
    key: '10',
    label: GovernanceLabel.G_GOVERNANCE_10,
    kpiId: '2-18',
    items: [
      {
        question:
          'a. Describe the processes for evaluating the performance of the highest governance body in overseeing the management of the organization’s impacts on the economy, environment, and people.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_36,
            fieldLabel: GovernanceLabel.G_QUESTION_36
          }
        ]
      },
      {
        question:
          'b. Report whether the evaluations are independent or not, and the frequency of the evaluations.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_37,
            fieldLabel: GovernanceLabel.G_QUESTION_37
          }
        ]
      },
      {
        question:
          'c. Describe actions taken in response to the evaluations, including changes to the composition of the highest governance body and organizational practices.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_38,
            fieldLabel: GovernanceLabel.G_QUESTION_38
          }
        ]
      }
    ]
  },
  {
    key: '11',
    label: GovernanceLabel.G_GOVERNANCE_11,
    kpiId: '2-19',
    items: [
      {
        question:
          'a. Describe the remuneration policies for members of the highest governance body and senior executives, including: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_22
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_39,
            fieldLabel: GovernanceLabel.G_QUESTION_39
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_23
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_40,
            fieldLabel: GovernanceLabel.G_QUESTION_40
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_24,
            tooltip:
              'Termination payments are all payments and benefits given to a departing member of the highest governance body or senior executive whose appointment is terminated. Termination payments extend beyond monetary payments, from transferring property to automatic or accelerated vesting of incentives. If the organization provides termination payments, it should explain whether: • notice periods for highest governance body members and senior executives are different from those for other employees. • termination payments for highest governance body members and senior executives are different from those for other employees. • departing highest governance body members and senior executives receive payments other than those related to the notice period. • any mitigation clauses are included in the termination arrangements.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_41,
            fieldLabel: GovernanceLabel.G_QUESTION_41
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_25,
            tooltip:
              'Clawbacks are repayments of previously received compensation that a highest governance body member or senior executive is required to make to their employer if certain conditions of employment or goals are not met.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_42,
            fieldLabel: GovernanceLabel.G_QUESTION_42
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_26,
            tooltip:
              'The organization should report the differences between the retirement benefit schemes and the contribution rates for the highest governance body members, senior executives, and all other employees.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_43,
            fieldLabel: GovernanceLabel.G_QUESTION_43
          }
        ]
      }
    ]
  },
  {
    key: '12',
    label: GovernanceLabel.G_GOVERNANCE_12,
    kpiId: '2-20',
    items: [
      {
        question: 'a. Describe the process for designing its remuneration policies and for determining remuneration, including:',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_27
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_50,
            fieldLabel: GovernanceLabel.G_QUESTION_50
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_28
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_51,
            fieldLabel: GovernanceLabel.G_QUESTION_51
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLabel.G_HEADING_29
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_52,
            fieldLabel: GovernanceLabel.G_QUESTION_52
          }
        ]
      },
      {
        question:
          'b. Describe how the remuneration policies for members of the highest governance body and senior executives relate to their objectives and performance in relation to the management of the organization’s impacts on the economy, environment, and people.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_44,
            fieldLabel: GovernanceLabel.G_QUESTION_44
          }
        ]
      }
    ]
  },
  {
    key: '13',
    label: GovernanceLabel.G_GOVERNANCE_13,
    kpiId: '2-21',
    items: [
      {
        question:
          'a. Report the ratio of the annual total compensation for the organization’s highest-paid individual to the median annual total compensation for all employees(excluding the highest-paid individual).',
        tooltip:
          'Annual total compensation includes salary, bonus, stock awards, option awards, non-equity incentive plan compensation, change in pension value, and nonqualified deferred compensation earnings provided over the course of a year. When calculating the ratio, the organization should, depending on the organization’s remuneration policies and availability of data, consider all of the following: • Base salary, which is the sum of guaranteed, short-term, and non-variable cash compensation. • Total cash compensation, which is the sum of the base salary and cash allowances, bonuses, commissions, cash profit-sharing, and other forms of variable cash payments. • Direct compensation, which is the sum of total cash compensation and total fair value of all annual long-term incentives (e.g., stock option awards, restricted stock shares or units, performance stock shares or units, phantom stock shares, stock appreciation rights, and long-term cash awards).',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: GovernanceKey.G_QUESTION_45,
            fieldLabel: GovernanceLabel.G_QUESTION_45
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: GovernanceKey.G_QUESTION_46,
            fieldLabel: GovernanceLabel.G_QUESTION_46
          }
        ]
      },
      {
        question:
          'b. Report the ratio of the percentage increase in annual total compensation for the organization’s highest-paid individual to the median percentage increase in annual total compensation for all employees (excluding the highest-paid individual).',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: GovernanceKey.G_QUESTION_47,
            fieldLabel: GovernanceLabel.G_QUESTION_47
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: GovernanceKey.G_QUESTION_48,
            fieldLabel: GovernanceLabel.G_QUESTION_48
          }
        ]
      },
      {
        question:
          'c. Report contextual information necessary to understand the data and how the data has been compiled.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceKey.G_QUESTION_49,
            fieldLabel: GovernanceLabel.G_QUESTION_49
          }
        ]
      }
    ]
  }
];

export const strategyPoliciesAndPracticesTabQuestions = [
  {
    key: '1',
    label:
      StrategyPoliciesAndPracticesLabel.SPAP_STRATEGY_POLICIES_AND_PRACTICES_1,
    kpiId: '2-22',
    items: [
      {
        question:
          'a. Report a statement from the highest governance body or most senior executive of the organization about the relevance of sustainable development to the organization and its strategy for contributing to sustainable development.',
        tooltip:
          '• Its short, medium, and long-term vision and strategy to manage its impacts on the economy, environment, and people, including impacts on their human rights, across the organization’s activities and business relationships; • how its purpose, business strategy, and business model aim to prevent negative impacts and achieve positive impacts on the economy, environment, and people; • its short and medium-term strategic priorities for contributing to sustainable development, including how the priorities are aligned with authoritative intergovernmental instruments; • the broader trends (e.g., macroeconomic, social, political) affecting the organization and its strategy for contributing to sustainable development; • the key events, achievements, and failures associated with the organization’s contribution to sustainable development during the reporting period; • a view of performance against goals and targets related to the organization’s material topics during the reporting period; • the organization’s main challenges, goals, and targets regarding its contribution to sustainable development for the next year and the coming three to five years.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_1,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_1
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label:
      StrategyPoliciesAndPracticesLabel.SPAP_STRATEGY_POLICIES_AND_PRACTICES_2,
    kpiId: '2-23',
    items: [
      {
        question:
          'a. Describe its policy commitments for responsible business conduct, including: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: StrategyPoliciesAndPracticesLabel.SPAP_HEADING_1
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_2,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_2
          },
          {
            fieldType: inputType.HEADING,
            heading: StrategyPoliciesAndPracticesLabel.SPAP_HEADING_2
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_3,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_3
          },
          {
            fieldType: inputType.HEADING,
            heading: StrategyPoliciesAndPracticesLabel.SPAP_HEADING_3,
            tooltip:
              'The precautionary principle is set out in Principle 15 of the UN Rio Declaration on Environment and Development [18]. It states: ‘Where there are threats of serious or irreversible damage, lack of full scientific certainty shall not be used as a reason for postponing cost-effective measures to prevent environmental degradation.’ The precautionary principle means taking early action to prevent and mitigate potential negative impacts in situations where conclusive scientific understanding or evidence is lacking, but there is sufficient reason to expect serious or irreversible damage. While the precautionary principle is most often associated with the protection of the environment, it can be applied to other areas, such as health and safety. The organization can describe the areas where it applies the precautionary principle.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_4,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_4
          },
          {
            fieldType: inputType.HEADING,
            heading: StrategyPoliciesAndPracticesLabel.SPAP_HEADING_4
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_5,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_5
          }
        ]
      },
      {
        question:
          'b. Describe its specific policy commitment to respect human rights, including: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: StrategyPoliciesAndPracticesLabel.SPAP_HEADING_5,
            tooltip:
              'Human rights are rights inherent to all human beings and are all interrelated, interdependent, and indivisible. The internationally recognized human rights include, at a minimum, the rights set out in the UN International Bill of Human Rights [15] and the principles concerning fundamental rights set out in the International Labour Organization (ILO) Declaration on Fundamental Principles and Rights at Work [5]. The UN International Bill of Human Rights consists of the Universal Declaration of Human Rights, the International Covenant on Economic, Social and Cultural Rights, and the International Covenant on Civil and Political Rights and its two Optional Protocols. Other UN instruments elaborate further on the rights of indigenous peoples. women. national or ethnic, religious and linguistic minorities. children. persons with disabilities. and migrant workers and their families. There are also standards of international humanitarian law that apply in situations of armed conflict, such as the International Committee of the Red Cross (ICRC) Geneva Conventions of 1949 [1]. At the regional level, binding treaties as well as non-binding instruments provide region-specific frameworks for human rights. If the policy commitment covers all internationally recognized human rights, a brief statement of this fact is sufficient to comply with the requirement. The organization can also state if the policy commitment references certain rights that require particular attention. For example, an organization can state that its policy commitment covers all internationally recognized human rights, and also references the rights to privacy and freedom of expression in particular because the organization has identified that its activities have an impact on these rights. If the policy commitment covers only some internationally recognized human rights, the organization is required to state the rights that are covered. It can explain why the policy commitment is limited to these rights.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_6,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_6
          },
          {
            fieldType: inputType.HEADING,
            heading: StrategyPoliciesAndPracticesLabel.SPAP_HEADING_6,
            tooltip:
              'Categories of stakeholders that the organization gives particular attention to can include consumers, customers, employees and other workers, and local communities. They can also include individuals belonging to groups or populations that are considered to be at risk or vulnerable groups, such as children. human rights defenders. indigenous peoples. migrant workers and their families. national or ethnic, religious and linguistic minorities. persons who might be discriminated against based on their sexual orientation, gender identity, gender expression, or sex characteristics. persons with disabilities. or women. For example, a bank may give particular attention in its policy commitment to avoid discriminating against specific categories of customers, or a mining organization may give particular attention to avoid infringing on the rights of indigenous peoples.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_7,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_7
          }
        ]
      },
      {
        question:
          'c. Provide links to the policy commitments if publicly available, or, if the policy commitments are not publicly available, explain the reason for this.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_8,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_8
          }
        ]
      },
      {
        question:
          'd. Report the level at which each of the policy commitments was approved within the organization, including whether this is the most senior level.',
        tooltip:
          'The most senior level may differ between organizations. For example, the most senior level in an organization could be the highest governance body (e.g., the board) or the most senior executive (e.g., chief executive officer). The organization can also report the dates of approval and adoption of the policy commitments, and how frequently the commitments are reviewed.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_9,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_9
          }
        ]
      },
      {
        question:
          'e. Report the extent to which the policy commitments apply to the organization’s activities and to its business relationships.',
        tooltip:
          'If the policy commitments apply to all of the organization’s activities and business relationships equally, a brief statement of this fact is sufficient to comply with the requirement. If the policy commitments apply to only some of the organization’s activities (e.g., they apply only to entities located in certain countries or to certain subsidiaries), the organization should report which activities the commitments apply to. It can also explain why the commitments are limited to these activities. If the policy commitments apply to only some of the organization’s business relationships, the organization should specify the types of business relationships the commitments apply to (e.g., distributors, franchisees, joint ventures, suppliers). It can also explain why the commitments are limited to these business relationships. The organization should also explain whether the business relationships are obligated to abide by the policy commitments or are encouraged (but not obligated) to do so',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_10,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_10
          }
        ]
      },
      {
        question:
          'f. Describe how the policy commitments are communicated to workers, business partners, and other relevant parties.',
        tooltip:
          'The organization can report: whether the policy commitments need to be read, agreed to, and regularly signed by all workers, business partners, and other relevant parties, such as governance body members. • the means through which it communicates the policy commitments (e.g., newsletters, formal or informal meetings, dedicated websites, contractual agreements). • how it identifies and removes potential barriers to the communication or dissemination of the policy commitments (e.g., by making them accessible and available in relevant languages).',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_11,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_11
          }
        ]
      }
    ]
  },
  {
    key: '3',
    label:
      StrategyPoliciesAndPracticesLabel.SPAP_STRATEGY_POLICIES_AND_PRACTICES_3,
    kpiId: '2-24',
    items: [
      {
        question:
          'a. Describe how it embeds each of its policy commitments for responsible business conduct throughout its activities and business relationships, including: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: StrategyPoliciesAndPracticesLabel.SPAP_HEADING_7,
            tooltip:
              '• The most senior level with oversight of, or accountability for, the implementation of the policy commitments. • the functions in the organization with day-to-day responsibility for implementing each of the policy commitments (e.g., human resources with the responsibility for implementing the commitment to respect the rights of workers), including: - their reporting lines to senior decision-making levels. - the reason for allocating the responsibility to them. • whether responsible business conduct is formally discussed at meetings of the highest governance body or senior executives and, if so, which topics are discussed. • whether there are other formal or systematic means for discussions about responsible business conduct between different levels or functions in the organization (e.g., a crossfunctional working group).'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_12,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_12
          },
          {
            fieldType: inputType.HEADING,
            heading: StrategyPoliciesAndPracticesLabel.SPAP_HEADING_8,
            tooltip:
              '• How it aligns the policy commitments with its: - broader risk management systems and management policies. - economic, environmental, social, and human rights impact assessments, and other due diligence processes. - policies and procedures that set financial and other performance incentives for management or workers. • how it applies the policy commitments when making decisions, such as about its sourcing and operating locations. • the systems (e.g., internal audit) it uses to monitor compliance with the policy commitments throughout its activities (across functions and geographic locations) and throughout its business relationships'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_13,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_13
          },
          {
            fieldType: inputType.HEADING,
            heading: StrategyPoliciesAndPracticesLabel.SPAP_HEADING_9,
            tooltip:
              '• Its procurement or investment policies and practices, and its engagement with those with which it has business relationships, including: - whether and how it applies pre-qualification processes, bidding criteria, or screening criteria consistent with the expectations stipulated in the policy commitments for responsible business conduct. - whether and how it considers the policy commitments in contracting or investment agreements, or in specific policies or codes of conduct for suppliers. • whether and how it considers the policy commitments in the process of determining whether to initiate, continue, or terminate a business relationship. • processes through which it enables or supports business partners and other parties to implement the policy commitments (e.g., capacity building, peer sharing). • incentives that it offers to business partners and other parties to implement the policy commitments (e.g., price premiums, increased orders, long-term contracts).'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_14,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_14
          },
          {
            fieldType: inputType.HEADING,
            heading: StrategyPoliciesAndPracticesLabel.SPAP_HEADING_10,
            tooltip:
              '• The content of the training. • to whom the training is provided, and whether it is mandatory. • the form (e.g., in-person, online) and frequency of the training. • examples of how the organization has determined that the training is effective.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_15,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_15
          }
        ]
      }
    ]
  },
  {
    key: '4',
    label:
      StrategyPoliciesAndPracticesLabel.SPAP_STRATEGY_POLICIES_AND_PRACTICES_4,
    kpiId: '2-25',
    items: [
      {
        question:
          'a. Describe its commitments to provide for or cooperate in the remediation of negative impacts that the organization identifies it has caused or contributed to.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_16,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_16
          }
        ]
      },
      {
        question:
          'b. Describe its approach to identify and address grievances, including the grievance mechanisms that the organization has established or participates in.',
        tooltip:
          'Grievance mechanisms refer to any routinized, state-based or non-state-based, judicial or nonjudicial processes through which stakeholders can raise grievances and seek remedy. Examples of state-based judicial and non-judicial grievance mechanisms include courts (for both criminal and civil actions), labor tribunals, national human rights institutions, National Contact Points under the OECD Guidelines for Multinational Enterprises, ombudsperson offices, consumer protection agencies, regulatory oversight bodies, and government-run complaints offices. Non-state-based grievance mechanisms include those administered by the organization, either alone or together with stakeholders, such as operational-level grievance mechanisms and collective bargaining, including the mechanisms established by collective bargaining. They also include mechanisms administered by industry associations, international organizations, civil society organizations, or multi-stakeholder groups. Operational-level grievance mechanisms are administered by the organization either alone or in collaboration with other parties and are directly accessible by the organization’s stakeholders. They allow for grievances to be identified and addressed early and directly, thereby preventing both harm and grievances from escalating. They also provide important feedback on the effectiveness of the organization’s due diligence from those who are directly affected. The organization can describe: • the intended purpose and users of the mechanisms (i.e., whether they are intended for a particular stakeholder category, topic, or region) and whether they enable users to raise human rights-related concerns. For example, the organization can explain that it has established a mechanism for community members to raise complaints about resettlement, as well as a separate hotline for workers to raise concerns about issues affecting their rights, such as health and safety conditions. • how the mechanisms operate and who administers them (the organization or another party). • whether operational-level grievance mechanisms are administered at the organizational level or whether they are administered at a lower level (at the site or project level) and, in such a case, how information from these mechanisms is centralized. • how the mechanisms have been designed and on which principles and guidelines they are based, including whether they are designed to meet the effectiveness criteria set out in UN Guiding Principle 31 [14]. • the process through which grievances are investigated. • whether grievances are communicated to the highest governance body. • whether grievances are treated confidentially. • whether the mechanisms can be used by stakeholders anonymously through representation by a third party. • whether the organization requires or provides incentives for the creation or improvement of operational-level grievance mechanisms in workplaces of suppliers. • whether the organization provides a back-up process for workplaces of suppliers that do not have operational-level grievance mechanisms or where the existing grievance mechanisms in those workplaces result in unresolved issues',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_17,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_17
          }
        ]
      },
      {
        question:
          'c. Describe other processes by which the organization provides for or cooperates in the remediation of negative impacts that it identifies it has caused or contributed to.',
        tooltip:
          'Requirement 2-25-c covers remediation processes other than grievance mechanisms. Such processes lead to the remediation of an impact without mechanisms for filing a formal complaint. Examples include instances where the organization takes action to remediate an actual impact evidenced in an impact assessment or a report published by a civil society organization.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_18,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_18
          }
        ]
      },
      {
        question:
          'd. Describe how the stakeholders who are the intended users of the grievance mechanisms are involved in the design, review, operation, and improvement of these mechanisms.',
        tooltip:
          'The organization can describe, for example, how it engages with stakeholders who are the intended users of the grievance mechanisms, to understand how they want to access the mechanisms to raise concerns, and their expectations about how the mechanisms will operate.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_19,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_19
          }
        ]
      },
      {
        question:
          'e. Describe how the organization tracks the effectiveness of the grievance mechanisms and other remediation processes, and report examples of their effectiveness, including stakeholder feedback.',
        tooltip:
          'According to UN Guiding Principle 31 [14], effective grievance mechanisms are legitimate, accessible, predictable, equitable, transparent, rights-compatible, and a source of continuous learning. In addition to these criteria, effective operational-level grievance mechanisms are also based on engagement and dialogue. It can be more difficult for the organization to assess the effectiveness of grievance mechanisms that it participates in compared to those it has established itself. The organization can report: • whether and how the intended users are informed about the grievance mechanisms and remediation processes. • whether and how the intended users are trained to use the grievance mechanisms and remediation processes. • the accessibility of the grievance mechanisms and remediation processes, such as the number of hours per day or days per week they are accessible, and their availability in different languages. • how the organization seeks to ensure it respects users’ human rights and protects them against reprisals (i.e., non-retaliation for raising complaints or concerns). • how satisfied users are with the grievance mechanisms and remediation processes, and with the resulting outcomes, as well as how the organization assesses user satisfaction. • the number and types of grievances filed during the reporting period, and the percentage of grievances that were addressed and resolved, including the percentage that were resolved through remediation. • the number of grievances filed during the reporting period that are repeated or recurring.  • changes made to the grievance mechanisms and remediation processes in response to lessons learned about their effectiveness.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_20,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_20
          }
        ]
      }
    ]
  },
  {
    key: '5',
    label:
      StrategyPoliciesAndPracticesLabel.SPAP_STRATEGY_POLICIES_AND_PRACTICES_5,
    kpiId: '2-26',
    items: [
      {
        question:
          'i. Seek advice on implementing the organization’s policies and practices for responsible business conduct.',
        tooltip:
          'The organization can report: • who the intended users of the mechanisms are. • how the mechanisms operate and which level or function in the organization is assigned responsibility for them. • whether the mechanisms are operated independently of the organization (e.g., by a third party). • the process through which concerns are investigated. • whether requests for advice and concerns raised are treated confidentially. • whether the mechanisms can be used anonymously',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_21,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_21
          }
        ]
      },
      {
        question:
          'ii. Raise concerns about the organization’s business conduct.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_22,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_22
          }
        ]
      }
    ]
  },
  {
    key: '6',
    label:
      StrategyPoliciesAndPracticesLabel.SPAP_STRATEGY_POLICIES_AND_PRACTICES_6,
    kpiId: '2-27',
    items: [
      {
        question:
          'a. Report the total number of significant instances of non-compliance with laws and regulations during the reporting period, and a breakdown of this total by: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: StrategyPoliciesAndPracticesLabel.SPAP_HEADING_11
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_23,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_23
          },
          {
            fieldType: inputType.HEADING,
            heading: StrategyPoliciesAndPracticesLabel.SPAP_HEADING_12
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_24,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_24
          }
        ]
      },
      {
        question:
          'b. Report the total number and the monetary value of fines for instances of noncompliance with laws and regulations that were paid during the reporting period, and a breakdown of this total by: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: StrategyPoliciesAndPracticesLabel.SPAP_HEADING_13
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_25,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_25
          },
          {
            fieldType: inputType.HEADING,
            heading: StrategyPoliciesAndPracticesLabel.SPAP_HEADING_14
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_26,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_26
          }
        ]
      },
      {
        question: 'c. Describe the significant instances of non-compliance.',
        tooltip:
          'The description of significant instances of non-compliance can include the geographic location where the instance occurred, and the matter to which the instance relates, such as a tax fraud or a spill. The organization is required to report sufficient information for information users to understand the type and the context of significant instances of non-compliance. The organization can also explain whether the significant instances are repeated or recurring.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_27,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_27
          }
        ]
      },
      {
        question:
          'd. Describe how it has determined significant instances of non-compliance.',
        tooltip:
          'When determining the significant instances of non-compliance, the organization can assess: • the severity of the impact resulting from the instance. • external benchmarks used in its sector to determine significant instances of non-compliance.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_28,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_28
          }
        ]
      }
    ]
  },
  {
    key: '7',
    label:
      StrategyPoliciesAndPracticesLabel.SPAP_STRATEGY_POLICIES_AND_PRACTICES_7,
    kpiId: '2-28',
    items: [
      {
        question:
          'a. Report industry associations, other membership associations, and national or international advocacy organizations in which it participates in a significant role.',
        tooltip:
          'The organization may have a significant role in an association or advocacy organization when it holds a position in the governance body, participates in projects or committees, or provides substantive funding beyond routine membership dues. The role may also be significant when the organization views its membership as strategic to influencing the mission or objective of the association that is critical to the organization’s own activities.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StrategyPoliciesAndPracticesKey.SPAP_QUESTION_29,
            fieldLabel: StrategyPoliciesAndPracticesLabel.SPAP_QUESTION_29
          }
        ]
      }
    ]
  }
];

export const stakeholderEngagementTabQuestions = [
  {
    key: '1',
    label: StakeholderEngagementLabel.SE_STAKEHOLDER_ENGAGEMENT_1,
    kpiId: '2-29',
    items: [
      {
        question:
          'a. Describe its approach to engaging with stakeholders, including:',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: StrategyPoliciesAndPracticesLabel.SPAP_HEADING_15,
            tooltip:
              'Common categories of stakeholders for organizations are business partners, civil society organizations, consumers, customers, employees and other workers, governments, local communities, non-governmental organizations, shareholders and other investors, suppliers, trade unions, and vulnerable groups. The organization can explain how it determines which categories of stakeholders to engage with and which categories not to engage with.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StakeholderEngagementKey.SE_QUESTION_1,
            fieldLabel: StakeholderEngagementLabel.SE_QUESTION_1
          },
          {
            fieldType: inputType.HEADING,
            heading: StrategyPoliciesAndPracticesLabel.SPAP_HEADING_16,
            tooltip:
              'The purpose of stakeholder engagement can be, for example, to identify actual and potential impacts or to determine prevention and mitigation responses to potential negative impacts. In some cases, stakeholder engagement is a right in and of itself, such as the right of workers to form or join trade unions or their right to bargain collectively.The organization can also report:• the type of stakeholder engagement (e.g., participation, consultation, information) and its frequency (e.g., ongoing, quarterly, annually);• when it engages directly with stakeholders and when it engages with credible stakeholder representatives or proxy organizations, or other credible independent expert resources, and why;• whether stakeholder engagement activities take place at the organizational level or at a lower level, such as at the site or project level, and in the latter case, how information from stakeholder engagement activities is centralized;• the resources (e.g., financial or human resources) allocated to stakeholder engagement.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StakeholderEngagementKey.SE_QUESTION_2,
            fieldLabel: StakeholderEngagementLabel.SE_QUESTION_2
          },
          {
            fieldType: inputType.HEADING,
            heading: StrategyPoliciesAndPracticesLabel.SPAP_HEADING_17,
            tooltip:
              'Meaningful stakeholder engagement is characterized by two-way communication and depends on the good faith of participants on both sides. It is also responsive and ongoing and includes in many cases engaging with relevant stakeholders before decisions are made. The organization can report: • how it takes into account potential barriers to stakeholder engagement (e.g., language and cultural differences, gender and power imbalances, divisions within a community or group). • how it engages with at-risk or vulnerable groups (e.g., whether it takes specific approaches and gives special attention to potential barriers). • how it provides stakeholders with information that is understandable and accessible through appropriate communication channels. • how stakeholder feedback is recorded and integrated into decision-making, and how stakeholders are informed about the way in which their feedback has influenced decisions. • how it seeks to respect the human rights of all stakeholders engaged, for example, their rights to privacy, freedom of expression, and peaceful assembly and protest. • how it works with business partners to engage with stakeholders in a meaningful way, including the expectations it places on business partners to respect the human rights of stakeholders during engagement.'
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StakeholderEngagementKey.SE_QUESTION_3,
            fieldLabel: StakeholderEngagementLabel.SE_QUESTION_3
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: StakeholderEngagementLabel.SE_STAKEHOLDER_ENGAGEMENT_2,
    kpiId: '2-30',
    items: [
      {
        question:
          'a. Report the percentage of total employees covered by collective bargaining agreements.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: StakeholderEngagementKey.SE_QUESTION_4,
            fieldLabel: StakeholderEngagementLabel.SE_QUESTION_4
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: StakeholderEngagementKey.SE_QUESTION_5,
            fieldLabel: StakeholderEngagementLabel.SE_QUESTION_5
          }
        ]
      },
      {
        question:
          'b. For employees not covered by collective bargaining agreements, report whether the organization determines their working conditions and terms of employment based on collective bargaining agreements that cover its other employees or based on collective bargaining agreements from other organizations.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: StakeholderEngagementKey.SE_QUESTION_6,
            fieldLabel: StakeholderEngagementLabel.SE_QUESTION_6
          }
        ]
      }
    ]
  }
];
